import { render } from "./FeatureSection.vue?vue&type=template&id=568a287a&scoped=true"
const script = {}

import "./FeatureSection.vue?vue&type=style&index=0&id=568a287a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568a287a"]])

export default __exports__